module.exports = __webpack_public_path__ + "static/media/bg2.adbad7d0.png";